const FLOOR_SHADOW_CONFIG = {
  lampOnShadowOpacity: 0.12,
  lampOffShadowOpacity: 0.08,
}

export { FLOOR_SHADOW_CONFIG };
